define.alias("shared/components/shared/plan-recommendation/steps/profiles", "calendar/components/shared/plan-recommendation/steps/profiles");